import React from 'react';

const styles = {
  Requested: { bg: '#F7E7EA', color: '#9C3D54', dot: '#9C3D54' },
  Fulfilled: { bg: '#FBEED8', color: '#8A5A1E', dot: '#B78140' },
  Shipped: { bg: '#E3EEF7', color: '#265f8a', dot: '#3a7db0' },
  Delivered: { bg: '#E1EEE4', color: '#2f6b41', dot: '#4D7C5F' },
  Rejected: { bg: '#F5D9D9', color: '#8a2f2f', dot: '#B84A4A' },
  Held: { bg: '#FBF3DA', color: '#8B6A1F', dot: '#B78140' },
  Active: { bg: '#E1EEE4', color: '#2f6b41', dot: '#4D7C5F' },
  Inactive: { bg: '#F1E4E4', color: '#8a2f2f', dot: '#a04747' },
  Eligible: { bg: '', color: '#2f6b41', dot: '#4D7C5F', outline: true },
  Locked: { bg: '', color: '#8A5A1E', dot: '#B78140', outline: true },
};

export default function StatusBadge({ status, small = false }) {
  // Case-insensitive normalisation — legacy imports may use ACTIVE / DEACTIVE
  const raw = String(status || '').trim();
  const key = raw.length
    ? raw[0].toUpperCase() + raw.slice(1).toLowerCase()
    : '';
  // Map legacy status aliases to their canonical badge style
  const alias = { Deactive: 'Inactive', Liquidate: 'Inactive' };
  const normalized = alias[key] || key;
  const s = styles[normalized] || { bg: '#EEE', color: '#333', dot: '#999' };
  if (s.outline) {
    return (
      <span className={`inline-flex items-center gap-1 ${small ? 'text-[11px]' : 'text-[12.5px]'} font-medium`} style={{ color: s.color }}>
        <span className="inline-block w-1.5 h-1.5 rounded-full" style={{ background: s.dot }} />
        {raw || status}
      </span>
    );
  }
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full ${small ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-[12px]'} font-medium`}
      style={{ background: s.bg, color: s.color }}
    >
      <span className="inline-block w-1.5 h-1.5 rounded-full" style={{ background: s.dot }} />
      {raw || status}
    </span>
  );
}
